export default __webpack_public_path__ + "static/skillsDevelopmentMobile-f264402090ec5b28e9aa33a1e71bda84.mp4";